import { useStudentPersonaSuspense } from '@features/personas/queries'
import { StudentSearchbar } from '@features/student-search/components/StudentSearchbar'
import { Avatar, Button, Card, Grid, Group, Stack, Text } from '@mantine/core'
import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'
import { usePortalTabs } from '@features/portal-tabs/usePortalTabs'
import { StudentSelectContextMenu } from '@features/portal-tabs/components/StudentSelectContextMenu'
import { Suspense } from 'react'
import { getPortalsApiResourceUrl } from '@services/api/portalApi'

export const Route = createFileRoute('/_layout/students/')({
    component: RouteComponent,
    beforeLoad: requireRouteAudience(['staff']),
})

const SuggestedStudent: React.FC<{ studentNo: string }> = ({ studentNo }) => {

    const { data: studentPersona } = useStudentPersonaSuspense(studentNo)
    const { openStudent } = usePortalTabs()

    return (
        <StudentSelectContextMenu studentNo={studentNo}>
            <Card
                withBorder
                className={'simple-hover'}
                onClick={() => openStudent(studentNo)}
                style={{ cursor: 'pointer' }}
            >
                <Group pr={'xs'}>
                    <Avatar src={studentPersona.photo?.url ? getPortalsApiResourceUrl(studentPersona.photo.url) : undefined} radius={'xl'} size={'lg'} />
                    <Stack gap={0}>
                        <Text size={'lg'} fw={500}>{studentPersona.displayName}</Text>
                        <Text c={'dimmed'}>{studentPersona.studentNumber}</Text>
                    </Stack>
                </Group>
            </Card>
        </StudentSelectContextMenu>
    )
}

const suggestedStudents = ['242180', '253001', '253002', '242427', '253763']

function RouteComponent() {

    return (
        <div className={'flex flex-col justify-center items-center h-full w-full gap-10'}>
            <StudentSearchbar searchbarProps={{ size: 'lg', radius: 'lg' }} />
            {/* <Stack justify='center'>
                <Text size={'sm'} fw={500} ta={'center'}>Or pick a random student:</Text>
                <Grid px={'xl'}>
                    {suggestedStudents.map((studentNo) => (
                        <Suspense key={studentNo} fallback={<Text>Loading...</Text>}>
                            <SuggestedStudent studentNo={studentNo} />
                        </Suspense>
                    ))}
                </Grid>
            </Stack> */}
        </div>
    )
}
